module.exports = __webpack_public_path__ + "/public/font/cc5404f3e1f36a83a26491732e7c483e.ttf";